
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"レイヤー 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 165","d":"M0 51.41v10.81A1.76 1.76 0 001.75 64h10.84a1.7 1.7 0 001.24-.53l38.82-38.79-13.36-13.33L.51 50.13A1.77 1.77 0 000 51.41zm63-37a3.53 3.53 0 000-5L54.64 1a3.54 3.54 0 00-5 0l-6.52 6.55 13.33 13.33L63 14.37z"}})])
          )
        }
      }
    